// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ClearCompanyDataModal_buttons__KGItM","title":"ClearCompanyDataModal_title__xeYL5"};